<template>
  <div class='ListItem' :class="{ gray: isPar(chave) }">
    <div style="width: 4%">
      <input :checked="checked" @change="toggle" type="checkbox">
    </div>
    <div style="width: 8%">
      <img-icon v-if="!data.img.length"/>
      <img v-if="data.img.length" :src="api + data.img[0].img">
    </div>
    <div class="c-name">{{ data.name }}</div>
    <div class="c-status">
      <div v-if="data.status" class="pub">Publicado</div>
      <div v-if="!data.status" class="arq">Arquivado</div>
    </div>
    <div v-if="data.tipo !== 'Variável'" style="width: 10%" class="mobile-none">{{ data.gerEstoque ? data.estoque : data.statusEstoque }}</div>
    <div v-if="data.tipo === 'Variável'" style="width: 10%" class="mobile-none">{{ data.estoqueVariavel.map(e => parseInt(e.src.quantidade)).reduce((c, a) => c + a, 0) }}</div>
    <div class="c-preco">
      <span :class="{ disabled: isString(data.oferta) > 0 }" style="display: block">{{ data.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span>
      <span v-if="isString(data.oferta) > 0" style="display: block; color: #20c997">{{ data.oferta.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span>
    </div>
    <div style="width: 10%" class="mobile-none">{{ JSON.parse(data.categoria)[0] }}</div>
    <div style="width: 4%" class="mobile-none">
      <box-icon
      v-if="Empresa.modelo !== 'Modelo 03'"
      :options="{ width: '13px', height: '13px' }"
      :text="data.tipo"
      :active="true"
      />
    </div>
    <div style="width: 4%" class="mobile-none">
      {{ data.visualizacao }}
    </div>
    <div style="width: 10%" class="mobile-none">{{ data.dateCreate }}</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BoxIcon from '../../Icons/BoxIcon'
import ImgIcon from '../../Icons/ImgIcon'
import api from '@/mixins/api'
export default {
  name: 'ListItem',
  props: ['data', 'chave'],
  components: { BoxIcon, ImgIcon },
  mixins: [api],
  computed: {
    ...mapGetters(['SelectedProds', 'Empresa']),
    status () {
      return this.data.visibilidade !== 'Oculto'
    },
    checked () {
      return this.SelectedProds.filter(s => s.id === this.data.id).length
    }
  },
  methods: {
    ...mapActions(['PushProdEdit', 'DeleteProdEdit']),
    toggle () {
      if(this.checked) {
        this.DeleteProdEdit(this.data)
      } else {
        this.PushProdEdit(this.data)
      }
    },
    isPar (n) {
      let d = n / 2
      return d % 1 === 0
    },
    isString (value) {
      return typeof value === 'string' ? parseFloat(value.replace(/\./g, '').replace('R$ ', '').replace(',', '.')) : value
    }
  }
}
</script>

<style scoped>
.ListItem {
  height: 10%;
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
}

img {
  width: 30px;
  height: 30px;
}

.pub {
  width: 80%;
  margin: auto;
  background-color: #20c997;
  color: #FFFFFF;
  padding: 3px;
  font-size: 12px;
  border-radius: 3px;
}

.arq {
  width: 80%;
  margin: auto;
  background-color: #f86c6b;
  color: #FFFFFF;
  padding: 3px;
  font-size: 12px;
  border-radius: 3px;
}

.disabled {
  color: red;
  text-decoration: line-through;
}

.gray {
  background-color: #F5F5F5F5;
}

.c-name {
  width: 25%;
  text-align: left;
}

.c-status {
  width: 8%;
}

.c-preco {
  width: 18%;
}

@media (max-width: 500px) {
  .ListItem {
    min-height: 15%;
  }
  .mobile-none {
    display: none;
  }
  .c-name {
    width: 50%;
  }
  .c-status {
    width: 20%;
  }
  .c-preco {
    width: 20%;
  }
}
</style>
